import template from "./import-costs-csv-modal.html";

const ImportCostsCsvModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class ImportCostsCsvModalController {
    /* @ngInject */
    constructor($rootScope, $window, $filter, Notification, Cost, Utils) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.$window = $window;
      this.NotificationService = Notification;
      this.Cost = Cost;
      this.Utils = Utils;
    }

    $onInit() {
      this.costsFile = null;
    }

    downloadCostsTemplate() {
      this.$window.open(
        `${process.env.CLIENT_URL}/resources/quoters-costs-template.csv`,
        "_blank"
      );
    }

    async importCsv() {
      try {
        this.saving = true;
        const formData = new FormData();
        formData.append("csvFile", this.costsFile);
        await this.Cost.importCsv(formData);
        this.costsFile = null;
        this.saving = false;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.costsImported"
          ),
        });

        this.close({ $value: true });
      } catch (error) {
        if (error.status === 400 && error.data.csv) {
          this.NotificationService.error({
            title: this.$filter("trans")(
              "notificationService.title.csvImportError"
            ),
          });
          const organization = this.$rootScope.organization;
          this.Utils.downloadCsv(
            error.data.csv,
            `ERROR-IMPORTING-${organization.name}-costs-${new Date()
              .toJSON()
              .slice(0, 10)}.csv`
          );
        } else {
          this.NotificationService.error({
            title: this.$filter("trans")("notificationService.title.ups"),
          });
        }
        this.close({ $value: false });
      } finally {
        this.costsFile = null;
        this.saving = false;
        this.$rootScope.$applyAsync();
      }
    }
  },
};

export default ImportCostsCsvModalComponent;
